export default class MercureAuthorizationPostResponse {
    public static fromData(data: any): MercureAuthorizationPostResponse {
        return new MercureAuthorizationPostResponse(data.token, data.topics, data.expires_in);
    }

    private readonly token: string;
    private readonly topics: string[];
    private readonly expiresInSeconds: number;

    constructor(token: string, topics: string[], expiresInSeconds: number) {
        this.token = token;
        this.topics = topics;
        this.expiresInSeconds = expiresInSeconds;
    }

    public getToken(): string {
        return this.token;
    }

    public getTopics(): string[] {
        return this.topics;
    }

    public getExpiresInSeconds(): number {
        return this.expiresInSeconds;
    }
}
